import { render, staticRenderFns } from "./DeleteMultipleMessages.vue?vue&type=template&id=a1daf6bc&scoped=true&lang=pug"
import script from "./DeleteMultipleMessages.vue?vue&type=script&lang=js"
export * from "./DeleteMultipleMessages.vue?vue&type=script&lang=js"
import style0 from "./DeleteMultipleMessages.vue?vue&type=style&index=0&id=a1daf6bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1daf6bc",
  null
  
)

export default component.exports